// A per-surface ERROR BOUNDARY (shell resilience). A surface render crash — e.g. a projection field the server
// did not send (a client/server contract drift) — is CONTAINED here: it renders an honest fallback instead of
// letting the error unmount the whole React root and blank the shell. SurfaceView keys it by surface id so
// switching surfaces resets it. A class component because React error boundaries require the class lifecycle
// (getDerivedStateFromError); React itself logs the underlying error to the browser console for diagnosis.

import { Component, type ReactNode } from 'react';

interface SurfaceErrorBoundaryProps {
  readonly children: ReactNode;
}

interface SurfaceErrorBoundaryState {
  readonly failed: boolean;
}

export class SurfaceErrorBoundary extends Component<
  SurfaceErrorBoundaryProps,
  SurfaceErrorBoundaryState
> {
  public override state: SurfaceErrorBoundaryState = { failed: false };

  public static getDerivedStateFromError(): SurfaceErrorBoundaryState {
    return { failed: true };
  }

  public override render(): ReactNode {
    if (this.state.failed) {
      return (
        <div className="screen-body">
          <div className="panel" style={{ padding: 'var(--space-6)' }}>
            <p className="text-md text-text">This section could not be displayed.</p>
            <p className="mt-2 text-sm text-text-subtle">
              The rest of the dashboard is unaffected — pick another section from the sidebar.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
